if (!customElements.get('pp-rolling-gallery')) {
  customElements.define('pp-rolling-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-roll-track]');
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: this.abort.signal });
      this.items = [...this.track.children];
      this.controls = this.querySelector('.pp-roll__controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const pause = () => { this.paused = true; this.update(); };
      if (this.controls) {
        listen(this.querySelector('[data-roll-previous]'), 'click', () => this.step(-1));
        listen(this.querySelector('[data-roll-next]'), 'click', () => this.step(1));
      }
      listen(this.track, 'pointerdown', pause);
      listen(this.track, 'wheel', pause);
      listen(this.track, 'keydown', pause);
      listen(this, 'focusin', pause);
      listen(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.update(); } });
      listen(this, 'pointerleave', () => { this.hovered = false; this.update(); });
      listen(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.update(); });
      listen(document, 'visibilitychange', () => this.update());
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.track);
      this.measure();
    }

    measure() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = this.items.reduce((sum, item) => sum + item.getBoundingClientRect().width, 0) + gap * (this.items.length - 1);
      const rolling = this.items.length > 1 && width > this.track.clientWidth;
      if (rolling && !this.clones) {
        this.clones = this.items.map(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          [clone, ...clone.querySelectorAll('[id],[data-shopify-editor-block]')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(clone);
          return clone;
        });
      }
      if (!rolling && this.clones) { this.clones.forEach(node => node.remove()); this.clones = null; }
      this.cycle = rolling ? Math.abs(this.clones[0].getBoundingClientRect().left - this.items[0].getBoundingClientRect().left) : 0;
      if (this.controls) this.controls.hidden = !rolling;
      this.update();
    }

    step(direction) {
      this.paused = true;
      this.update();
      if (!this.cycle) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = this.items[0].getBoundingClientRect().width + gap;
      const position = (Math.abs(this.track.scrollLeft) + direction * distance + this.cycle) % this.cycle;
      this.track.scrollLeft = this.direction * position;
    }

    update() {
      cancelAnimationFrame(this.frame);
      if (!this.cycle || this.paused || this.hovered || !this.visible || document.hidden) return;
      let position = Math.abs(this.track.scrollLeft) % this.cycle;
      let previous = performance.now();
      const tick = now => {
        position = (position + Math.min(now - previous, 50) * 0.028) % this.cycle;
        previous = now;
        this.track.scrollLeft = this.direction * position;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.clones?.forEach(node => node.remove());
      this.clones = null;
      this.abort = null;
    }
  });
}
